import { configureStore } from '@reduxjs/toolkit';
import proficienciesReducer from "~/store/proficienciesReducer.js";
import initialStateReducer from '~/store/initialStateReducer.js';
import certificationsReducer from "~/store/certificationsReducer.js";
import featuresReducer from '~/store/featuresReducer.js';
import siteConfigReducer from '~/store/siteConfigReducer.js';
import accountsReducer from '~/store/accountsReducer.js';
import enrollmentsReducer from '~/store/enrollmentsReducer.js';
import proficiencyCompletionsReducer from '~/store/proficiencyCompletionsReducer.js';
import certificationProficienciesReducer from '~/store/certificationProficienciesReducer.js';
import promptSetsReducer from '~/store/promptSetsReducer.js';
import promptResponsesReducer from "~/store/promptResponsesReducer.js";
import trainingProfilesReducer from '~/store/trainingProfilesReducer.js';
import promptSetSubmissionsReducer from '~/store/promptSetSubmissionsReducer.js';
import certificationExamResultsReducer from '~/store/certificationExamResultsReducer.js';

const store = configureStore({
    reducer: {
        proficiencies: proficienciesReducer.reducer,
        initialState: initialStateReducer.reducer,
        certifications: certificationsReducer.reducer,
        features: featuresReducer.reducer,
        siteConfig: siteConfigReducer.reducer,
        accounts: accountsReducer.reducer,
        enrollments: enrollmentsReducer.reducer,
        proficiencyCompletions: proficiencyCompletionsReducer.reducer,
        certificationProficiencies: certificationProficienciesReducer.reducer,
        promptSets: promptSetsReducer.reducer,
        promptResponses: promptResponsesReducer.reducer,
        trainingProfiles: trainingProfilesReducer.reducer,
        promptSetSubmissions: promptSetSubmissionsReducer.reducer,
        certificationExamResults: certificationExamResultsReducer.reducer,
    }
});

export const actions = {
    proficiencies: proficienciesReducer.actions,
    initialState: initialStateReducer.actions,
    certifications: certificationsReducer.actions,
    features: featuresReducer.actions,
    siteConfig: siteConfigReducer.actions,
    accounts: accountsReducer.actions,
    enrollments: enrollmentsReducer.actions,
    proficiencyCompletions: proficiencyCompletionsReducer.actions,
    certificationProficiencies: certificationProficienciesReducer.actions,
    promptSets: promptSetsReducer.actions,
    promptResponses: promptResponsesReducer.actions,
    trainingProfiles: trainingProfilesReducer.actions,
    promptSetSubmissions: promptSetSubmissionsReducer.actions,
    certificationExamResults: certificationExamResultsReducer.actions,
};

// store.subscribe(() => console.log(store.getState()));

export default store;